<template>
  <div v-if="!item.hidden && (item.group || item.children)" class="menu-wrapper">

    <!--<router-link v-if="hasOneShowingChild(item.children) && !onlyOneChild.children && !item.alwaysShow" :to="resolvePath(onlyOneChild.path)">
      <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
        <svg-icon v-if="onlyOneChild.meta&&onlyOneChild.meta.icon" :icon-class="onlyOneChild.meta.icon"></svg-icon>
        <span v-if="onlyOneChild.meta&&onlyOneChild.meta.title" slot="title">{{onlyOneChild.meta.title}}&#45;&#45;00</span>
      </el-menu-item>
    </router-link>-->
    {{parentName}}
    <div class="menu-group" v-if="item.group" v-for="group in item.group">
      <div class="menu-subtitle" v-if="group.subtitle && group.route.length">{{group.subtitle}}</div>
      <ul v-for="child in group.route" v-if="!child.hidden">
        <sidebar-item :is-nest="true" class="nest-menu"  v-if="child.group&&child.group.length>0" :item="child" :key="child.name" :base-path="resolvePath(child.path)" :parent-name="child.meta.title"></sidebar-item>

        <router-link v-else :to="resolvePath(child.path)" :key="child.name">
          <el-menu-item :index="resolvePath(child.path)" :class="{'is-active':child.name==parentName}">
            <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
          </el-menu-item>
        </router-link>
      </ul>
    </div>

    <div v-else class="menu-group">
      <div class="menu-subtitle" v-if="item.meta&&(item.meta.subtitle || item.meta.title)">{{item.meta.subtitle || item.meta.title}}</div>
      <ul v-for="child in item.children" v-if="!child.hidden">
        <sidebar-item :is-nest="true" class="nest-menu" v-if="child.children&&child.children.length>0" :item="child" :key="child.path" :base-path="resolvePath(child.path)" :parent-name="parentName"></sidebar-item>

        <router-link v-else :to="resolvePath(child.path)" :key="child.name">
          <el-menu-item :index="resolvePath(child.path)" :class="{'is-active':child.name==parentName}">
            <span v-if="child.meta&&child.meta.title" slot="title">{{child.meta.title}}</span>
          </el-menu-item>
        </router-link>
      </ul>
    </div>


  </div>
</template>

<script type="text/ecmascript-6">
import path from 'path'

export default {
  name: 'SidebarItem',
  props: {
    // 路由对象
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    parentName:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      group:[],
      onlyOneChild: null
    }
  },
  watch:{
    item(){
      console.log('肉',item.meta.subtitle.length)
    },
    onlyOneChild(){

    }
  },
  methods: {
    hasOneShowingChild(children) {
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          //临时集（如果只有一个显示子将使用）
          this.onlyOneChild = item
          return true
        }
      })
      if (showingChildren.length === 1) {
        return true
      }
      return false
    },
    resolvePath(...paths) {
      return path.resolve(this.basePath, ...paths)
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/SidebarItem.vue